// Doc https://material-table.com/#/docs/all-props https://github.com/mbrn/material-table

import React, { Fragment, useState, useEffect } from "react";
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import MaterialTable, { MTableToolbar } from "material-table";
import { withStyles } from '@material-ui/core/styles';
import * as H from 'helper';

const Top10TxByCampaign = ({
    classes,
    title,
    source,
    loading,
    dataByGame,
    selectedCurrency,
    depPrice,
    metric,
    metricLabel,
}) => {
    const [geoData, setGeoData] = useState([]);

    useEffect(() => {
        //console.log('yoyo');
    }, []);

    useEffect(() => {
        let dataSource = dataByGame[metric][source];
        if (dataSource.length > 0) {
            let totalNum = dataSource[0]['value'];
            let dataArray = [], dataObj = {};
            for (let i=0; i<dataSource.length; i++) {
                dataObj.no = i+1;
                dataObj.title = dataSource[i]['title'];
                dataObj.num_amount = selectedCurrency === 'dep' ? dataSource[i]['value'] : calcConvert(selectedCurrency, dataSource[i]['value']);
                dataObj.num_ratio = (dataSource[i]['value'] / totalNum * 100).toFixed(2);
                dataArray.push(dataObj);
                dataObj = {};
            }
            setGeoData(dataArray);
        }
    }, [dataByGame, selectedCurrency]);

    const getCurrencyLbl = (selectedCurrency) => {
        let lblToReturn = metricLabel;
        if (selectedCurrency === 'usd') {
            lblToReturn = lblToReturn + " (US$)";
        } else if (selectedCurrency === 'sgd') {
            lblToReturn = lblToReturn + " (S$)";
        } else if (selectedCurrency === 'jpy') {
            lblToReturn = lblToReturn + " (¥)";
        }
        return lblToReturn;
    };

    const calcConvert = (currency, amount) => {
        let amtReturn = 0;
        if (currency === 'usd') {
            amtReturn = amount * depPrice.usd;
        } else if (currency === 'sgd') {
            amtReturn = amount * depPrice.sgd;
        } else if (currency === 'jpy') {
            amtReturn = amount * depPrice.jpy;
        }
        return amtReturn;
    };

    return(
        <MaterialTable
            isLoading={loading.ovByGame}
            style={{padding: 16, fontSize: 14, minHeight: 280}}
            title={<div style={{fontSize: 18, fontWeight: 500, color: '#000'}}>{title}</div>}
            columns={[
                { title: '#', field: 'no', width: 50, cellStyle: {textAlign:'center'}},
                { title: 'ゲーム', field: 'title', width: 350,
                    render: rowData => <Fragment>
                                            <div style={{display:'flex'}}>
                                                <div style={{paddingTop: 4}}>{rowData.title}</div>
                                            </div>
                                        </Fragment>
                },
                { title: getCurrencyLbl(selectedCurrency), field: 'value', width: 200, type: 'numeric', cellStyle: {textAlign:'center'},
                    render: rowData => <div>{H.FormatNumStrHelper.formatCommaThousand(rowData.num_amount)}</div>},
                { title: '全体比率',field: 'num_ratio', type: 'numeric', cellStyle: {textAlign:'left', marginLeft: 32},
                    render: rowData => <Fragment>
                                            <div style={{display:'flex', height: 16}}>
                                                <div style={{paddingRight: 16, width: 24}}>{rowData.num_ratio}%</div>
                                                <div style={{backgroundColor: '#65C9A5', width:rowData.num_ratio+'%', marginLeft: 20, marginTop:3}}></div>
                                            </div>
                                        </Fragment>
                },
            ]}
            data={geoData}
            options={{
                search: false,
                paging: false,
                sorting: false,
                rowStyle: {
                    textAlign:'center',
                },
                headerStyle: {textAlign:'center'}
            }}
            localization={{
                body: {
                    emptyDataSourceMessage: '表示可能なデータがありません',
                },
            }}
        />
    )
};

Top10TxByCampaign.propTypes = {
    classes: PropTypes.object,
};

const mapStateToProps = state => ({
    loading: state.nftDepOverview.loading,
    dataByGame: state.nftDepOverview.dataByGame,
    selectedCurrency: state.page.selectedCurrency,
    depPrice: state.page.depPrice,
});

const mapDispatchToProps = dispatch => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(null, { withTheme: true })(Top10TxByCampaign));
